import { Redirect } from 'react-router-dom'

import type { TWinninAuthRouterPermissionsView } from './winnin-auth-router-permissions.types'

export const WinninAuthRouterPermissionsView = ({
  children,
  shouldRedirect,
  redirectTo,
}: TWinninAuthRouterPermissionsView) => {
  if (shouldRedirect) {
    return <Redirect to={redirectTo} />
  }

  return <>{children}</>
}
